<section class="sbnb-onboarding">
  <sbnb-user-header
    *ngIf="mode !== 'code'"
    [back]="mode === 'forgotpw' || mode === 'link' || mode === 'email' ? '/user/hello' : ''"></sbnb-user-header>

  <sbnb-user-header *ngIf="mode === 'code'" [back]="'/user'"></sbnb-user-header>

  <article class="main">
    <sbnb-login-form
      *ngIf="mode === 'login'"
      [redirectUrl]="returnUrl"
      [email]="email"
      (stateChange)="routeToMagicLink($event)"></sbnb-login-form>

    <sbnb-forgot-pw-form #forgotPwCmp *ngIf="mode === 'forgotpw'"></sbnb-forgot-pw-form>

    <sbnb-magic-link-success
      *ngIf="mode === 'link'"
      [deviceIsTrusted]="isDeviceAlreadyTrusted"
      [email]="email"></sbnb-magic-link-success>

    <ng-template
      *ngIf="mode === 'code'"
      [ngTemplateOutlet]="codeEntryTemplate"
      [ngTemplateOutletContext]="{ email: email }"></ng-template>

    <div *ngIf="isAndroid" class="text-center privacy-policy-container">
      <a class="text__small raspberry-darker" [href]="config.PRIVACY_POLICY_URL" target="_blank">Privacy policy</a>
    </div>
  </article>

  <aside>
    <div style="height: 563px; display: flex; align-items: flex-end; justify-content: center">
      <img *ngIf="mode === 'login' || mode === 'email'" src="/assets/images/login/login.svg" />
      <img *ngIf="mode === 'forgotpw' && !forgotPwCmp?.success" src="/assets/images/login/forgot-pw.svg" />
      <img *ngIf="mode === 'forgotpw' && forgotPwCmp?.success" src="/assets/images/login/forgot-pw-success.svg" />
      <img *ngIf="mode === 'link' || mode === 'code'" src="/assets/images/login/login.svg" />
    </div>
  </aside>
</section>

<ng-template #codeEntryTemplate let-email="email">
  <section fxLayout="column" fxLayoutGap="30px">
    <div *ngIf="isDeviceAlreadyTrusted" fxLayout="column" fxLayoutGap="12px">
      <h2>Check your email to login</h2>
      <p>
        We've sent a code to your email which you can use to login to
        {{ 'CORE.PRODUCT_NAME' | transloco }}.
      </p>
    </div>

    <div *ngIf="!isDeviceAlreadyTrusted" fxLayout="column" fxLayoutGap="12px">
      <h2>We don't recognise this device</h2>
      <p>
        In order to verify your identity, we've sent a code to your email
        <strong>{{ email }}</strong>
        .
      </p>
    </div>

    <sbnb-otp-input [size]="4" [(ngModel)]="magicLinkCode"></sbnb-otp-input>

    <ng-container *ngIf="!isDeviceAlreadyTrusted">
      <sbnb-button
        [fullWidth]="true"
        [loading]="loadingTrust"
        [disabled]="magicLinkCode.length < 4"
        (clicked)="processMagicCodeLogin(true)">
        Login and trust this device
      </sbnb-button>

      <sbnb-button
        [fullWidth]="true"
        type="secondary"
        [loading]="loading"
        [disabled]="magicLinkCode.length < 4"
        (clicked)="processMagicCodeLogin(false)">
        Login once
      </sbnb-button>
    </ng-container>

    <ng-container *ngIf="isDeviceAlreadyTrusted">
      <sbnb-button
        [fullWidth]="true"
        [loading]="loading"
        [disabled]="magicLinkCode.length < 4"
        (clicked)="processMagicCodeLogin(true)">
        Login
      </sbnb-button>
    </ng-container>
  </section>
</ng-template>
